import React from 'react';

interface VersionProps {
	label?: React.ReactNode;
}

export const Version: React.FC<VersionProps> = props => {
	return <div className="app-version">{props.label}</div>;
};
